<template>
    <a-modal
        :visible="visible"
        :title="`${selectedCount} kişiyi okundu olarak işaretle`"
        @ok="handleConfirm"
        @cancel="handleCancel"
        ok-text="İşaretle"
        cancel-text="İptal"
        width="450px"
    >
        <div class="modal-content">
            <p>Seçili {{ selectedCount}} kişi okundu olarak işaretlenecek. Devam etmek istiyor musunuz?</p>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: "BulkMarkAsReadModal",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        handleConfirm() {
            this.$emit("confirm", {
                action: "mark-as-read",
                payload: { unread: false },
            });
        },
        handleCancel() {
            this.$emit("cancel");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    p {
        font-size: 14px;
        color: #586069;
        margin: 0;
    }
}
</style>

